// extracted by mini-css-extract-plugin
export default {"movies-container":"MovieCardContainer_movies-container__BzV1b"};